export const FillPaint = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4.5" y="26.5" width="23" height="3" fill="currentColor" stroke="currentColor"/>
<path d="M16 12V2" stroke="currentColor" stroke-width="2"/>
<rect x="16.3778" y="5.07861" width="12.7805" height="15.4804" transform="rotate(47.5 16.3778 5.07861)" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M24 21C24 21.5523 24.4477 22 25 22C25.5523 22 26 21.5523 26 21L24 21ZM26 21L26 14.4162L24 14.4162L24 21L26 21Z" fill="currentColor"/>
</svg>`;
